/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { TmHttpClient } from '@treasury/core/http';
import { Injectable } from '@treasury/utils/dependency-injection';
import { createSwaggerClient } from '../../utils/tm-swagger-client';

import { BaseResponse2Dto, SaveCompanyStopPaymentRequestDto } from '../';
import { ContentType, HttpClient, RequestParams } from './http-client';

@Injectable()
export class StopPaymentClient {
    private readonly http: HttpClient;

    constructor(tmHttp: TmHttpClient) {
        this.http = createSwaggerClient(tmHttp, HttpClient);
    }

    /**
     * No description
     *
     * @tags StopPayment
     * @name StopPaymentGetEligibleStopPaymentAccounts
     * @summary Gets eligible stop payment accounts.
     * @request GET:/StopPayment/GetEligibleStopPaymentAccounts/{companyId}
     */
    stopPaymentGetEligibleStopPaymentAccounts = (companyId: number, params: RequestParams = {}) =>
        this.http.request<BaseResponse2Dto, any>({
            path: `/StopPayment/GetEligibleStopPaymentAccounts/${companyId}`,
            method: 'GET',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags StopPayment
     * @name StopPaymentGetCompanyConfiguration
     * @summary Gets company configurations for stop payments.
     * @request GET:/StopPayment/GetCompanyConfiguration/{companyId}
     */
    stopPaymentGetCompanyConfiguration = (companyId: number, params: RequestParams = {}) =>
        this.http.request<BaseResponse2Dto, any>({
            path: `/StopPayment/GetCompanyConfiguration/${companyId}`,
            method: 'GET',
            format: 'json',
            ...params,
        });
    /**
     * No description
     *
     * @tags StopPayment
     * @name StopPaymentSaveCompanyConfiguration
     * @summary Posts stop payment configuration for a given company.
     * @request POST:/StopPayment/SaveCompanyConfiguration
     */
    stopPaymentSaveCompanyConfiguration = (
        request: SaveCompanyStopPaymentRequestDto | null,
        params: RequestParams = {}
    ) =>
        this.http.request<BaseResponse2Dto, any>({
            path: `/StopPayment/SaveCompanyConfiguration`,
            method: 'POST',
            body: request,
            type: ContentType.Json,
            format: 'json',
            ...params,
        });
}
